export function getLCFListingTypeSelectedEventPayload(isEntirePlace: boolean) {
  return {
    property_type: isEntirePlace ? 'Entire place' : 'Private room',
  };
}
